<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">
        <img class="exclamation" src="../../../../assets/img/sweep/cashier/exlamation.webp" alt="Exclamation" />
        KYC Required
    </div>
    <img class="persona" src="../../../../assets/img/sweep/cashier/persona.webp" alt="Persona" />
    <div class="sopo-popup-text">
        To use SOPO Sweepstakes, users must go through a brief KYC process via Persona on the mobile app.
        <ul class="list-holder">
            <li class="paragraph-main">Click either of the app store links below to get started. It will only take a moment. </li>
            <li class="paragraph-main">If you've already completed this process on your SOPO account, you can disregard this message and continue.</li>
            <li class="paragraph-main">Note that this is not required to use other gameplay options on SOPO.</li>
        </ul>
    </div>
    <div class="download">
        <img
            class="badge"
            src="../../../../assets/img/header/app-store-badge.webp"
            alt="App store"
            (click)="openLink('https://apps.apple.com/us/app/sopo-social-poker/id1441432679')"
        />
        <img
            class="badge clickable"
            src="../../../../assets/img/header/play-store-badge.webp"
            alt="Play store"
            (click)="openLink('https://play.google.com/store/apps/details?id=software.odysseus.sopo')"
        />
    </div>
    <div class="sopo-popup-green-button clickable" (click)="close()">CLOSE</div>
</div>
